'use client';
import classNames from 'classnames';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import EcoButton from 'eco-design/base/eco-button';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import { useEffect, useState } from 'react';
import './index.scss';
import { Swiper, SwiperSlide } from 'swiper/react';

export default function Content({ id, data = {}, initIndex = 0, isEditStatus = false }: ContentServerProps) {
    const { label, title, desc, labelType, list = [] } = data;
    const prefixCls = 'index-tab-list-a';
    const prefixClsA = 'index-tab-list-a-box1';
    const prefixClsB = 'index-tab-list-a-box2';
    const [activeIndexA, setActiveIndexA] = useState(initIndex);
    const firstItemA = list[isEditStatus ? initIndex : activeIndexA] || {};
    const [itemsB, setItemsB] = useState(firstItemA.list2 || []);
    const recommended_title = list[activeIndexA]?.recommended_title || ''; //推荐标题
    const tabChangeA = (itemA: any, index: number) => {
        setActiveIndexA(index);
        setItemsB(itemA.list2 || []);
    };
    useEffect(() => {
        setItemsB(firstItemA.list2 || []);
    }, [data, firstItemA, firstItemA.list2]);

    return (
        <GloLayout className={`editor-index-tab-list-a`} id={id} data={data}>
            <div className="eco-content-v2 index-tab-list-a-info">
                {labelType === 'DIY' && label && <p className={`${prefixCls}-label`}>{label}</p>}
                {labelType === 'NO1' && (
                    <div className={`${prefixCls}-label default`}>
                        <span>Global</span>
                        <img src="https://websiteoss.ecoflow.com/upload/image/1764140591441/icon.png" draggable="false" />
                        <span>Portable Power Station in Sales*</span>
                    </div>
                )}
                <h2 className={`${prefixCls}-title`}>{title}</h2>
                <p className={`${prefixCls}-desc`}>{desc}</p>
            </div>

            <Swiper className={`${prefixCls}-tabs-list`} slidesPerView="auto" initialSlide={initIndex}>
                {list.map((itemA: any, index: number) => {
                    const itemClassesA = classNames({
                        [`${prefixCls}-tabs-item`]: true,
                        [`${prefixCls}-tabs-item-active`]: activeIndexA === index,
                    });
                    return (
                        <SwiperSlide key={index} className={itemClassesA} onClick={() => tabChangeA(itemA, index)}>
                            {itemA.tab_name}
                        </SwiperSlide>
                    );
                })}
            </Swiper>
            <div className="eco-content-v2">
                <div className={prefixClsA}>
                    <div
                        className={classNames({
                            [`${prefixClsA}-item`]: true,
                            [`${prefixClsA}-theme-${firstItemA.theme}`]: firstItemA.theme,
                        })}
                    >
                        <div
                            className={`${prefixClsA}-item-img`}
                            onClick={() => {
                                if (firstItemA?.lHref) {
                                    window.open(firstItemA.lHref, '_blank');
                                }
                            }}
                        >
                            <EcoImgVideo isVideo={firstItemA?.isVideo} pc={firstItemA?.pc} h5={firstItemA?.h5} />
                        </div>
                        <div className={`${prefixClsA}-item-msg`}>
                            <div className={`${prefixClsA}-item-info`}>
                                {firstItemA?.label && <div className={`${prefixClsA}-item-label`}>{firstItemA?.label}</div>}
                                {firstItemA?.title && <div className={`${prefixClsA}-item-title`}>{firstItemA?.title}</div>}
                                {firstItemA?.desc && <div className={`${prefixClsA}-item-desc`}>{firstItemA?.desc}</div>}
                            </div>
                            <div
                                className={`${prefixClsA}-item-box-btn`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                            >
                                <EcoButton
                                    lTheme={firstItemA?.theme}
                                    lType="text"
                                    lHref={firstItemA?.lHref}
                                    lChildren={firstItemA?.lBtnContent}
                                    lIsWithRightArrow={true}
                                />
                                <EcoButton
                                    lTheme={firstItemA?.theme}
                                    lType="text"
                                    lHref={firstItemA?.rHref}
                                    lChildren={firstItemA?.rBtnContent}
                                    lIsWithRightArrow={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`eco-content-v2`}>
                <div className={`${prefixClsB}-title`}>{recommended_title}</div>
            </div>

            <ul className={`${prefixClsB}-list length-${itemsB.length}`}>
                {itemsB.map((itemA: any, index: number) => {
                    const { label, title, desc, theme = 'white' } = itemA;
                    return (
                        <li key={index} className={`${prefixClsB}-item length-${itemsB.length}`}>
                            <div
                                className={`${prefixClsB}-item-img`}
                                onClick={() => {
                                    if (itemA.lHref) {
                                        window.open(itemA.lHref, '_blank');
                                    }
                                }}
                            >
                                <EcoImgVideo isVideo={itemA.isVideo} pc={itemA.pc} h5={itemA.h5} />
                            </div>
                            <div className={`${prefixClsB}-item-msg`}>
                                <div className={`${prefixClsB}-item-info`}>
                                    {label && <div className={`${prefixClsB}-item-label`}>{label}</div>}
                                    {title && <div className={`${prefixClsB}-item-title`}>{title}</div>}
                                    {desc && <div className={`${prefixClsB}-item-desc`}>{desc}</div>}
                                </div>
                                <div className={`${prefixClsB}-item-box-btn`}>
                                    <EcoButton
                                        className={`${prefixClsB}-item-box-btn-item`}
                                        lTheme="black"
                                        lType="filled"
                                        lRadius="ellipse"
                                        lHref={itemA.lHref}
                                        lChildren={itemA.lBtnContent}
                                    />
                                    <EcoButton
                                        className={`${prefixClsB}-item-box-btn-item`}
                                        lTheme="black"
                                        lType="outlined"
                                        lRadius="ellipse"
                                        lHref={itemA.rHref}
                                        lChildren={itemA.rBtnContent}
                                    />
                                </div>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </GloLayout>
    );
}
